module.exports = __webpack_public_path__ + "img/placeholder.15890f08.png";